"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _setmeal = require("@/api/iot/setmeal");
var _default = {
  props: ['editItem'],
  data: function data() {
    return {
      dialogVisible: false,
      formData: {
        id: 0,
        merchant_id: '',
        name: '',
        amount: 0,
        min_amount: 0,
        expire_day: 1,
        status: 1
      },
      merchantList: [],
      rules: {
        merchant_id: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入优惠券名称',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '请输入价格',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0.01,
          message: '价格必须大于0',
          trigger: 'blur'
        }],
        expire_day: [{
          required: true,
          message: '请输入有效期',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '有效期必须大于0',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '优惠券';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            for (var key in _this.formData) {
              _this.formData[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
  },
  methods: {
    reset: function reset() {
      this.formData = this.$options.data().formData;
      this.$refs['form'].resetFields();
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    submit: function () {
      var _submit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$refs['form'].validate().catch(function (err) {});
              case 2:
                valid = _context2.sent;
                if (!valid) {
                  _context2.next = 7;
                  break;
                }
                (0, _setmeal.editCoupon)({
                  form_data: this.formData
                }).then(function (res) {
                  _this2.dialogVisible = false;
                  _this2.$emit('getList');
                });
                _context2.next = 9;
                break;
              case 7:
                this.$message({
                  message: '请检查表单错误',
                  type: 'error'
                });
                return _context2.abrupt("return", false);
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};
exports.default = _default;